import { jsx } from 'react/jsx-runtime';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';

const PopoverPanel = ({ children, className, ...rest })=>{
    const props = {
        ...rest,
        className: classNames('popover-panel', className)
    };
    return jsx(Headlessui.Transition, {
        as: Headlessui.Popover.Panel,
        "data-testid": "popover-panel",
        enter: "transition ease duration-200 transform",
        enterFrom: "opacity-0 -translate-y-2",
        enterTo: "opacity-100 translate-y-0",
        leave: "transition ease duration-200 transform",
        leaveFrom: "opacity-100 translate-y-0",
        leaveTo: "opacity-0 -translate-y-2",
        ...props,
        children: jsx(Headlessui.Popover.Panel, {
            children: children
        })
    });
};
PopoverPanel.displayName = 'Popover.Panel';

export { PopoverPanel };
//# sourceMappingURL=Popover.Panel.es.js.map
